const actions = {
    EXTENSION_GET_EXTENSION_LIST_REQUEST: 'EXTENSION_GET_EXTENSION_LIST_REQUEST',
    EXTENSION_GET_EXTENSION_LIST_SUCCESS: 'EXTENSION_GET_EXTENSION_LIST_SUCCESS',
    EXTENSION_GET_EXTENSION_LIST_ERROR: 'EXTENSION_GET_EXTENSION_LIST_ERROR',

    // MPS Extension
    EXTENSION_MPS_READ_OPTION_LIST_REQUEST: 'EXTENSION_MPS_READ_OPTION_LIST_REQUEST',
    EXTENSION_MPS_READ_OPTION_LIST_SUCCESS: 'EXTENSION_MPS_READ_OPTION_LIST_SUCCESS',
    EXTENSION_MPS_READ_OPTION_LIST_ERROR: 'EXTENSION_MPS_READ_OPTION_LIST_ERROR',
    EXTENSION_MPS_UPDATE_OPTION_LIST_REQUEST: 'EXTENSION_MPS_UPDATE_OPTION_LIST_REQUEST',
    EXTENSION_MPS_UPDATE_OPTION_LIST_SUCCESS: 'EXTENSION_MPS_UPDATE_OPTION_LIST_SUCCESS',
    EXTENSION_MPS_UPDATE_OPTION_LIST_ERROR: 'EXTENSION_MPS_UPDATE_OPTION_LIST_ERROR',
    EXTENSION_MPS_SYNCHRONISE_REQUEST: 'EXTENSION_MPS_SYNCHRONISE_REQUEST',
    EXTENSION_MPS_SYNCHRONISE_SUCCESS: 'EXTENSION_MPS_SYNCHRONISE_SUCCESS',
    EXTENSION_MPS_SYNCHRONISE_ERROR: 'EXTENSION_MPS_SYNCHRONISE_ERROR',
    EXTENSION_RESET_STATE: 'EXTENSION_RESET_STATE',

    getExtensionList: () => ({
        type: actions.EXTENSION_GET_EXTENSION_LIST_REQUEST,
    }),
    mps: {
        mpsReadOptionList: () => ({
            type: actions.EXTENSION_MPS_READ_OPTION_LIST_REQUEST,
        }),
        mpsUpdateOptionList: request => ({
            type: actions.EXTENSION_MPS_UPDATE_OPTION_LIST_REQUEST,
            request,
        }),
        mpsSynchronise: () => ({
            type: actions.EXTENSION_MPS_SYNCHRONISE_REQUEST,
        }),
    },
    resetState: () => ({
        type: actions.EXTENSION_RESET_STATE,
    }),
};
export default actions;
